import type { BreadCrumb, BreadCrumbs } from './types';

export const INITIAL_BREADCRUMBS = () =>
  Array<BreadCrumb>({
    name: 'bigcrafters',
    url: '/',
  }) as BreadCrumbs;
